/**
 * useAPI — thin hook exposing the shared API client verbs.
 *
 * Returns module-level singleton functions, so the references are stable
 * across renders. This matters: Dashboard does `useEffect(fetch, [get])`,
 * and a fresh `get` each render would loop the analytics fetch forever.
 */
import { get, post, put, del } from '../api/client';

export default function useAPI() {
  return { get, post, put, del };
}
